import { arrayToQuery, url as encodeUrl } from "../utils/UrlUtil";
import { Request } from "../stores/Requests20";
import { handleServiceResponse } from "./ServerRequestsInternal";
import type { DidYouForgetPrediction } from "../stores/customer-cart/CartRecommendationStore";
const BASE_URL = "/ordercapture/cartmancer/did-you-forget";
const TIMEOUT = 2000;
export async function getDidYouForgetRecommendation(
	customerId: string,
	fsdAddressId: string | null | undefined,
	bundleIds: Array<string>,
	country: string,
	storeId: string,
	locale: string,
): Promise<DidYouForgetPrediction> {
	const url =
		BASE_URL +
		encodeUrl`/recommendation?customerId=${customerId}&country=${country}&storeId=${storeId}&locale=${locale}` +
		`&${arrayToQuery(bundleIds, "bundleIds")}` +
		`${fsdAddressId ? "&addressId=" + fsdAddressId : ""}`;
	const response = Request.get(url).timeout(TIMEOUT).execute();
	return (await handleServiceResponse(response)).data;
}
export async function downvoteBundle(country: string, storeId: string, customerId: string, bundleId: string) {
	const url =
		BASE_URL +
		encodeUrl`/downvote?country=${country}&storeId=${storeId}&customerId=${customerId}&bundleId=${bundleId}`;
	const response = Request.put(url).timeout(TIMEOUT).execute();
	await handleServiceResponse(response);
}
